
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 24/02/2025
 * @update 24/02/2025
 * @file src/components/W17/W17F1404
 */

import { Column } from "devextreme-react/data-grid";
import { Button, ButtonIcon, Checkbox, Col, DatePicker, Dropdown, Image, Modal, ModalBody, ModalHeader, Popover, PopoverBody, Row, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import PropTypes from "prop-types";
import React, { forwardRef, memo, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F1404Actions from "../../actions/w17/w17F1404/w17F1404-actions";
import Config from "../../config";
import FileViewer from "../common/fileviewer/fileviewer";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loading";

const FormID = 'W17F1404';

const useStyles = makeStyles((theme) => ({
    ellipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    popAction: {
        minWidth: 196,
        padding: theme.spacing([2, 0, 2, 0])
    },
    btnActionItem: {
        display: 'flex',
        width: '100%',
        justifyContent: 'start',
        color: theme.colors.primary
    },
    btnDownload: {
        position: 'absolute',
        bottom: 0,
        right: 0,
    },
    imageModal: {
        minHeight: 126,
        maxHeight: 570,
        overflowY: 'scroll'
    }
}));

const initialDataMaster = {
    SalesPersionID: '',
    SalesPersionName: '',
    CustomerID: '',
    DateFrom: null,
    DateTo: null,
};

const W17F1404 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
    const [cboFilterCustomerLoading, setCboFilterMonthLoading] = useState(false);
    const [dataMaster, setDataMaster] = useState(initialDataMaster);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    const [dataCboCustomer, setDataCboCustomer] = useState([]);
    const [dynamicCol, setDynamicCol] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);

    const gridRef = useRef(false);
    const gridContainerRef = useRef(false);
    const popMoreRef = useRef(null);
    const currentRowClick = useRef(null);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadForm();
        loadCboEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        loadCboCustomer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataMaster.SalesPersionID]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (isPer) => {
            setIPermission(isPer);
        })
    };

    const loadCboEmployee = () => {
        setCboEmployeeLoading(true);
        props.W17F1404Actions.loadCboEmployee((error, data) => {
            setCboEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboEmployee(data);
            }
        })
    };

    const loadCboCustomer = () => {
        const { SalesPersionID = '' } = dataMaster;
        const params = {
            SalesPersionID
        };
        setCboFilterMonthLoading(true);
        props.W17F1404Actions.loadCboCustomer(params, (error, data) => {
            setCboFilterMonthLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboCustomer(data);
            }
        })
    };

    const loadForm = () => {
        const { DateFrom = null, DateTo = null, SalesPersionID = '', CustomerID = '' } = dataMaster;
        const params = {
            SalesPersionID,
            CustomerID,
            DateFrom,
            DateTo,
        };
        setFormLoading(true);
        props.W17F1404Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { columns = [], rows = [] } = data || {};
                setDynamicCol(columns);
                setDataGrid(rows);
            }
        });
    };

    const onExportExcel = () => {
        const { DateFrom = null, DateTo = null, SalesPersionID = '', SalesPersionName = '', CustomerID = '' } = dataMaster;
        const params = {
            SalesPersionID,
            CustomerID,
            DateFrom,
            DateTo,
        };
        let line01 = '';
        if (!Config.isEmpty(SalesPersionName)) line01 = '-';
        const title = `${Config.lang('Bao_cao_vieng_tham_khach_hang')} ${line01} ${SalesPersionName}`;
        Config.exportExcel(params, '/w17f1404/export', title);
    };

    const onView = () => {
        loadForm();
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        let objPlus = { [fieldName]: value };
        if (fieldName === 'SalesPersionID') objPlus = { ...objPlus, SalesPersionName: e?.data?.EmployeesName || '' };
        else if (['DateFrom', 'DateTo'].includes(fieldName) && Config.isEmpty(value)) objPlus[fieldName] = null;
        setDataMaster({ ...dataMaster, ...objPlus });
    };

    const renderCheckBoxCol = (e) => {
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
        />;
    };

    const renderMaxWidthColum = (e, maxWidth = 300) => { // default max width 300
        const value = e?.value || '';
        return <div title={value} className={classes.ellipsis}
            {...(Config.typeOf(maxWidth, 'number') ? { style: { maxWidth } } : {})} >{value}</div>
    };

    const handleRenderCol = () => {
        let result = [];
        for (let i = 0; i < dynamicCol.length; i++) {
            let objPlus = {};
            let type = 'varchar';
            const { Alignment = 'left', FieldName = '', Caption = '', DataType = '', Visible = true, Width = 150, IsPermanent } = dynamicCol[i] || {};
            if (DataType) type = ['decimal', 'varchar', 'int', 'datetime'].find(item => DataType.search(item) > -1);
            switch (type) {
                case 'decimal': // Number
                    objPlus = {
                        alignment: 'right',
                        dataType: 'number'
                    };
                    break;
                case 'varchar': // String
                    objPlus = {
                        alignment: 'left',
                    };
                    break;
                case 'datetime': // Ngày
                    objPlus = {
                        dataType: 'date',
                        alignment: 'center',
                        format: 'dd/MM/yyyy',
                        editorOptions: { placeholder: 'DD/MM/YYYY' }
                    };
                    break;
                case 'int': // CheckBox / Toggle...
                    objPlus = {
                        alignment: 'center',
                        cellRender: (e) => renderCheckBoxCol(e)
                    };
                    break;
                default:
                    break;
            }
            if (IsPermanent === 1) objPlus = { // PIN Cột
                ...objPlus,
                fixed: true,
                visibleIndex: null,
                fixedPosition: 'left',
            };
            result.push(<Column key={i}
                dataField={FieldName}
                caption={Caption}
                width={Width}
                alignment={Alignment}
                visible={Visible}
                cellRender={(e) => renderMaxWidthColum(e)}
                {...objPlus}
            />)
        }
        return result;
    };

    const handleOpenAttachmentModal = (status = false, isSave = false) => {
        setOpenAttachmentModal(status);
        if (isSave) loadForm(); // load lại form
    };

    const renderAction = (e) => {
        return (
            <Popover ref={e => popMoreRef.current = e}
                anchor={<ButtonIcon
                    viewType={'ghost'}
                    name={'Menu'}
                />}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}>
                <PopoverBody className={classes.popAction}>
                    <Button
                        viewType={'text'}
                        color={'primary'}
                        startIcon={'View'}
                        className={classes.btnActionItem}
                        label={Config.lang('Xem_anh_dinh_kem')}
                        labelProps={{ style: { textTransform: 'capitalize' } }}
                        onClick={() => {
                            if (popMoreRef.current) popMoreRef.current.close();
                            currentRowClick.current = e?.data || {};
                            setOpenAttachmentModal(true);
                        }}
                    />
                </PopoverBody>
            </Popover>
        );
    };

    const renderGrid = useMemo(() => {
        let column = [];
        if (!Config.isEmpty(dynamicCol)) column = handleRenderCol(dynamicCol);
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }))
        return (
            <GridContainer
                pagerFullScreen
                reference={ref => (gridRef.current = ref)}
                ref={ref => (gridContainerRef.current = ref)}
                dataSource={dataSource}
                isPer={iPermission}
                loading={formLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                height={Config.getHeightGrid() - 120}>
                <Column
                    cellRender={(e) => renderAction(e)}
                    caption={Config.lang('Thao_tac')}
                    alignment={'center'}
                    allowEditing={false}
                    allowSorting={false}
                    fixed={true}
                    width={100}
                />
                {column}
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, dynamicCol, formLoading]);

    if (!iPermission) return null;
    return (
        <div className='page-container'>
            <Row>
                {openAttachmentModal && <AttachmentModal
                    open={openAttachmentModal}
                    handleOpen={(status, isSave) => handleOpenAttachmentModal(status, isSave)}
                    dataRow={currentRowClick.current}
                    dataForm={dataMaster}
                    {...props}
                />}
                <Col xs={12}><Typography color={'info'} type={'h4'}>{Config.lang('Bao_cao_vieng_tham_khach_hang')}</Typography></Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'EmployeeID'}
                        displayExpr={'EmployeesName'}
                        label={Config.lang('Nhan_vien')}
                        disabled={formLoading}
                        loading={cboEmployeeLoading}
                        value={dataMaster?.SalesPersionID}
                        dataSource={dataCboEmployee || []}
                        onChange={e => onChange('SalesPersionID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'CustomerID'}
                        displayExpr={'CustomerName'}
                        label={Config.lang('Khach_hang')}
                        disabled={formLoading}
                        loading={cboFilterCustomerLoading}
                        value={dataMaster?.CustomerID}
                        dataSource={dataCboCustomer || []}
                        onChange={e => onChange('CustomerID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={3}>
                    <Row>
                        <Col xs={6}>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                label={Config.lang('Tu')}
                                disabled={formLoading}
                                max={dataMaster?.DateTo}
                                value={dataMaster?.DateFrom}
                                onChange={e => onChange('DateFrom', e)}
                            />
                        </Col>
                        <Col xs={6}>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                label={Config.lang('Den')}
                                disabled={formLoading}
                                min={dataMaster?.DateFrom}
                                value={dataMaster?.DateTo}
                                onChange={e => onChange('DateTo', e)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} verticalAlign={'end'}>
                    <Button
                        disabled={formLoading}
                        label={Config.lang('Xuat_excel')}
                        viewType={'outlined'}
                        color={'success'}
                        startIcon={'Sheet'}
                        onClick={onExportExcel}
                    />
                    <Button
                        disabled={formLoading}
                        label={Config.lang('Xem')}
                        viewType={'filled'}
                        color={'info'}
                        startIcon={'View'}
                        className={'mgl2x'}
                        onClick={onView}
                    />
                </Col>
                <Col xs={12}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

const AttachmentModal = memo(forwardRef((props) => {
    const classes = useStyles();
    const { open, handleOpen, dataRow } = props;
    const [showFileViewer, setShowFileViewer] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [fileInfo, setFileInfo] = useState({});
    const [dataImage, setDataImage] = useState([]);


    const loadAttachmentImage = () => {
        const { EmployeeID: SalesPersionID = '', CustomerID = '', TaskID = '' } = dataRow || {};
        const params = {
            SalesPersionID,
            CustomerID,
            DateFrom: null,
            DateTo: null,
            TaskID
        };
        setFormLoading(true);
        props.W17F1404Actions.loadAttachmentImage(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataImage(data);
            }
        });
    };

    useEffect(() => {
        loadAttachmentImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDownload = (data) => {
        fetch(data.filePath).then(function (response) {
            return response.blob();
        }).then(function (myBlob) {
            var objectURL = URL.createObjectURL(myBlob);
            const link = document.createElement('a');
            link.href = objectURL;
            link.setAttribute('download', data.FileName);
            document.body.appendChild(link);
            link.click();
        });
    }

    const handleImageClick = (data = {}) => {
        setFileInfo(data);
        setShowFileViewer(true);
    }

    const renderImageBoard = useMemo(() => {
        if (Config.isEmpty(dataImage)) return '';
        let arrAtt = [];
        for (let i = 0; i < dataImage.length; i++) {
            const { Title = '', Image: image = '', FileName = '' } = dataImage[i] || {};
            arrAtt.push(<Col xs={12} key={i}>
                <div className={'full_w display_row'}>
                    <div style={{ minWidth: 90, cursor: 'pointer' }} onClick={() => handleImageClick(dataImage[i])}><Image square src={image} width={90} height={90} objectFit={'cover'} onClick={() => handleImageClick(dataImage[i])} /></div>
                    <div className={'pdl4x'} style={{ position: 'relative' }}>
                        <Typography hoverTooltip lineClamp={1} type={'h3'}>{FileName}</Typography>
                        <Typography type={'p3'} lineClamp={3}>{Title}</Typography>
                        <ButtonIcon circular className={classes.btnDownload} name={'Download'} color={'primary'} viewType={'text'} onClick={() => onDownload(dataImage[i])} />
                    </div>
                </div>
            </Col>);
        }
        return arrAtt;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataImage]);

    return (
        <>
            {/* Modal List Image */}
            <Modal open={open} size={'sm'} onClose={() => handleOpen()}>
                <ModalHeader title={Config.lang('Anh_dinh_kem')} />
                <ModalBody className={classes.imageModal}>
                    {formLoading && <Loading />}
                    <Row>{renderImageBoard}</Row>
                </ModalBody>
            </Modal>
            {/* Modal Detail Image */}
            <Modal open={showFileViewer} size={'xl'} onClose={() => setShowFileViewer(false)}>
                <ModalHeader title={' '} />
                <ModalBody>
                    <FileViewer fileName={fileInfo?.FileName} filePath={fileInfo?.Image} fileType={fileInfo?.FileExt} height={'calc(100vh - 90px)'} style={{ background: 'black' }} />
                </ModalBody>
            </Modal>
        </>
    );
}));

AttachmentModal.defaultProps = {
    open: false,
    dataForm: {},
    dataRow: {},
};

AttachmentModal.PropTypes = {
    open: PropTypes.bool,
    dataForm: PropTypes.object,
    dataRow: PropTypes.object,
    handleOpen: PropTypes.func
};

export default connect(null, (dispatch) => ({
    W17F1404Actions: bindActionCreators(W17F1404Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F1404);


